import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "@apollo/client/react/hoc";
import compose from "lodash.flowright";
import { GET_LOCAL_SHOPPING_CART } from "../../../graphql/resolvers/cart";
import breakpoints from "../../../styles/breakpoints";
import { header, transition } from "../../../styles/variables";
import { isLoggedIn } from "../../../helpers/auth";

const OptionsAndSearchFilterContainer = styled.div`
  position: static;
  padding-top: 30px !important;

  ${breakpoints.smDown} {
    position: sticky;
    position: -webkit-sticky;
    z-index: 199;
    top: ${(props) => props.smTop};
    background-color: white;
    transform: ${(props) => (props.isShown ? "translateY(0)" : "translateY(-175%)")};
    transition: ${transition.searchFilterBarTransition};
  }
`;

const OptionsSearchFilterContainer = ({ children, isShown, isInMyCellar = false, ...props }) => {
  /**
   * Checks if Box/Cart tab bar is active on screen top
   * ...to help with top position of new search bar on smDown screens.
   *
   * @returns {Boolean}
   * */
  const hasCartOrBoxTabBarOnTop = () => {
    if (isLoggedIn()) {
      return true;
    }
    const { getLocalShoppingCart } = props;
    const { localShoppingCart } = getLocalShoppingCart || {};
    const { visible, items } = localShoppingCart || {};
    const smallScreenHasCartOnTop = visible && items && items.length > 0;
    return smallScreenHasCartOnTop;
  };

  /**
   * Calculates the top position of search and filters bar.
   *
   * @returns {String}
   * */
  const getSmTop = () => {
    if (isInMyCellar) {
      // CASE: Is in My Cellar Received (PAst Wines) page.
      return header.withBoxAndCartTrayMobileHeight; // [DEV-3051] Update when deprecating toggle feature flag.
    }
    return hasCartOrBoxTabBarOnTop() ? header.withBoxAndCartTrayMobileHeight : header.mobileHeight;
  };

  return (
    <OptionsAndSearchFilterContainer isShown={isShown} smTop={getSmTop()}>
      {children}
    </OptionsAndSearchFilterContainer>
  );
};

OptionsSearchFilterContainer.propTypes = {
  getLocalShoppingCart: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
  isShown: PropTypes.bool.isRequired,
  isInMyCellar: PropTypes.bool,
};

export default compose(graphql(GET_LOCAL_SHOPPING_CART, { name: "getLocalShoppingCart" }))(
  OptionsSearchFilterContainer
);
